import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectServiceDeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-redirect',
	path: '/jira/servicedesk/projects/:projectKey',
	exact: true,
};
